<template>
    <div>

        <div class="row row-cols-1 row-cols-lg-2 g-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Allgemein') }}</legend>
                            <text-input label="name" v-model="form.name" :error="form.errors.name" />
                            <text-input label="slug" v-model="form.slug" :error="form.errors.slug" />
                            <text-input label="short_name" v-model="form.short_name" readonly disabled />
                            <div v-if="!manufacturer || manufacturer.aliases.length === 0">
                                <hr />
                                <!--@todo autocompleter-->
                                <select-input label="aliased_id" v-model="form.aliased_id" :error="form.errors.aliased_id">
                                    <option :value="null">{{ __('Kein') }}</option>
                                    <option :value="manufacturer.id" v-for="manufacturer in manufacturers">
                                        {{ manufacturer.name }}  (#{{ manufacturer.id }})
                                    </option>
                                </select-input>
                                <checkbox-input label="aliases_checked" v-model="form.aliases_checked" :error="form.errors.aliases_checked" />
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>

            <!--@todo logo-->

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('SEO') }}</legend>
                            <text-input label="meta_title" v-model="form.meta_title" :error="form.errors.meta_title" />
                            <textarea-input label="meta_description" v-model="form.meta_description" :error="form.errors.meta_description" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col w-100">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Seiteninhalt') }}</legend>
                            <editor-input label="description" v-model="form.description" :error="form.errors.description" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col w-100" v-if="manufacturer">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Aliases') }}</legend>
                            <ul v-if="manufacturer.aliases.length">
                                <li v-for="alias in manufacturer.aliases">
                                    <inertia-link :href="route('admin.manufacturers.edit', alias)">
                                        {{ alias.name }}    
                                    </inertia-link>
                                </li>
                            </ul>
                            <div v-else>
                                {{ __('None') }}
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center w-100">
                <submit-button :form="form" />
                <button type="button" class="btn link-danger" @click="destroy" v-if="manufacturer">
                    {{ __('Put in trash') }}
                </button>
            </div>

        </div>

    </div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';
    import EditorInput from '@/shared/Inputs/EditorInput';

    export default {
        props: [
            'form',
            'manufacturer',
            'manufacturers',
        ],
        data() {
            return {

            }
        },
        components: {
            TextInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
            EditorInput,
        },
        watch: {
        },
        methods: {
            destroy() {
                this.$inertia.delete(this.route('admin.manufacturers.destroy', this.manufacturer));
            },
        },
    }
</script>
